<template>
  <div class="edit-snps-div">
    <div class="edit-snps">
      <div class="confirmation-popup" v-if="filename">
        <span class="exit" @click="clearInput">
          <i class="fas fa-times-circle"></i>
        </span>
        <div class="confirmation">ARE YOU SURE YOU WANT TO UPLOAD</div>
        <div class="filename">{{ filename }}</div>
        <div>
          <button class="confirm-button" @click="processFile">Confirm</button>
        </div>
      </div>
      <div class="back-div">
        <router-link to="/home" class="back-router">
          <i class="fas fa-chevron-circle-left"></i>
        </router-link>
        <span class="back-text">Back</span>
      </div>
      <h3>Add/Remove SNP</h3>
      <div v-if="snps.length">
        <label for="snps-Input" class="upload-snps">Choose File</label>
        <input id="snps-Input" ref="snpsInput" type="file" @change="readFile" />
      </div>
      <div v-if="error" class="error">Error: {{ error }}</div>
      <div class="message" v-if="snpsAddedCount">Added {{ snpsAddedCount }} snp(s)</div>
      <div class="message" v-if="message">{{ message }}</div>
      <div class="snp-container" v-if="snps.length">
        <div v-for="snp of snps" :key="snp.snpId" class="snp-loop">
          <ul class="snp-row">
            <li class="snp-text">{{snp.snpId}}</li>
            <li class="trash">
              <i class="fas fa-trash-alt" @click="snpRemovalPrompt(snp.snpId)"></i>
            </li>
          </ul>
        </div>
      </div>
      <div v-else>Loading...</div>
    </div>
    <!-- Modal defined here -->
    <modal name="removeSnpModal" height="auto">
      <div class="modal-container">
        <div class="confirm-text">
          Are you sure you want to delete
          <span class="red-text">{{ snpToDelete }}</span>?
        </div>
        <div class="buttons-container">
          <button @click="removeSnp(snpToDelete)">Yes</button>
          <button @click="$modal.hide('removeSnpModal')">No</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import firebase from '@/javascript/firebase';
import _ from 'lodash';

const db = firebase.firestore();
const date = firebase.firestore.FieldValue.serverTimestamp;

export default {
  data() {
    return {
      error: '',
      snps: [],
      snpToDelete: '',
      filename: '',
      snpsAddedCount: 0,
      message: '',
    };
  },
  firestore: {
    snps: db.collection('snps').orderBy('created', 'desc'),
  },
  methods: {
    async removeSnp(snpId) {
      this.snpsAddedCount = 0;
      this.$modal.hide('removeSnpModal');
      await db.runTransaction(async (t) => {
        const count = this.snps.length - 1;
        t.delete(db.collection("snps").doc(snpId));
        t.set(db.collection("counts").doc("snps"), {
          count,
          updated: date(),
        });
      });

      this.snpToDelete = '';
    },
    snpRemovalPrompt(snpId) {
      this.snpToDelete = snpId;
      this.$modal.show('removeSnpModal');
    },
    readFile(event) {
      this.filename = event.target.files[0].name;
    },
    async processFile() {
      this.message = '';
      this.snpsAddedCount = 0;
      const file = this.$refs.snpsInput.files[0];
      const snpList = await file.text();
      const snpMap = _.keyBy(this.snps, 'snpId');

      try {
        const snpsChunks = _.chain(snpList.trim().split('\n'))
          .map((snpId) => snpId.trim())
          .uniq() // de-duplicate the list
          .filter((snpId) => !snpMap[snpId]) // and don't add an existing snpId
          // A write batch can contain maximum of 500 writes, here 499 + the count write per batch.
          .chunk(499)
          .value();

        let count = this.snps.length;
        for (const chunk of snpsChunks) {
          const batch = db.batch();
          for (const snpId of chunk) {
            batch.set(db.collection("snps").doc(snpId), {
              snpId,
              // Add flag to indicate we need to poll dbSNP
              dbSNP: null,
              created: date(),
              updated: date(),
            });
            this.snpsAddedCount += 1;
          }
          count += chunk.length;
          batch.set(db.collection("counts").doc("snps"), {
            count,
            updated: date(),
          });
          await batch.commit();
        }

        if (!this.snpsAddedCount)
          this.message = 'All these snp(s) already exist(s)';
      } catch (error) {
        this.error = error.message;
        // eslint-disable-next-line
        console.error(error);
      }
      this.clearInput();
    },
    clearInput() {
      this.filename = '';
      this.$refs.snpsInput.value = '';
    },
  },
};
</script>

<style scoped>
.edit-snps-div {
  padding-top: 5vh;
  margin-left: 20vw;
  margin-bottom: 3vh;
}

.confirmation-popup {
  position: absolute;
  left: 0;
  right: 0;
  background: rgb(251, 168, 168);
  color: white;
  font-size: 18px;
  border-radius: 5px;
  padding: 20px;
}

.confirmation {
  font-weight: bold;
}

.filename {
  color: black;
  margin-bottom: 10px;
}

.exit {
  position: absolute;
  top: 5px;
  right: 5px;
}

.exit:hover {
  color: rgb(228, 70, 70);
  cursor: pointer;
}

.confirm-button {
  background: rgb(50, 47, 192);
  border: none;
  color: white;
  border-radius: 5px;
  padding: 5px 10px;
}

.confirm-button:hover {
  background: rgba(49, 47, 192, 0.8);
}

.edit-snps {
  position: relative;
  overflow: auto;
  max-width: 20vw;
  height: 80vh;
  background: #fffffff0;
  padding: 30px;
  border: 3px solid rgb(228, 70, 70);
  border-radius: 5px;
}

.upload-snps {
  background: rgb(50, 47, 192);
  color: white;
  border-radius: 5px;
  padding: 5px 20px;
}

.upload-snps:hover {
  background: rgba(49, 47, 192, 0.8);
  cursor: pointer;
}

.message {
  margin-top: 15px;
  font-weight: bold;
  color: rgb(39, 170, 39);
}

.back-div {
  text-align: left;
}

.fa-chevron-circle-left {
  color: gray;
  margin-right: 0.5rem;
}

.fa-chevron-circle-left:hover {
  cursor: pointer;
  color: blue;
}

.back-router:hover + .back-text {
  visibility: visible;
}

.back-text {
  visibility: hidden;
}

.error {
  color: rgb(228, 70, 70);
  margin-top: 15px;
}

.snp-container {
  margin: 1rem auto;
  display: block;
}

.snp-loop {
  display: block;
  margin: 0.5rem;
}

.snp-row {
  display: flex;
  padding: 0;
  margin-top: 0.1vh;
}

li {
  list-style: none;
  flex: 1;
}

.trash {
  margin-right: 0;
}

.fa-trash-alt {
  color: gray;
}

.fa-trash-alt:hover {
  cursor: pointer;
  color: rgb(228, 70, 70);
}

.snp-text {
  margin-right: 0.5rem;
  text-align: right;
  color: black;
}

.snp-text:hover {
  font-weight: bold;
}

.modal-container {
  padding: 2rem;
}

.confirm-text {
  text-align: center;
}

.red-text {
  color: rgb(228, 70, 70);
}

.buttons-container {
  text-align: center;
  margin: 1rem auto;
}

button {
  padding: 0.2rem 1rem;
  margin: 0 0.5rem;
}

button:hover {
  cursor: pointer;
}
</style>
